import { fullScript } from '@/utils/script-utils'

export function loadSirv(components) {
    return new Promise((resolve) => {
      const scriptIsInstalled = document.querySelector('#mainSirv')

      if( scriptIsInstalled ){
        document.body.removeChild(scriptIsInstalled)
      }
      
      const modules = components.length ? `?modules=${components}` : ''
      const script = document.createElement('script');
      script.id = 'mainSirv'
      script.src = `${fullScript}${modules}`;
      script.type = 'text/javascript';
      script.async = true;
      script.onload = resolve;
      document.body.appendChild(script);
    });
}